var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.299,
    height: 96.758,
    viewBox: "-11.121 -21.019 87.299 96.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.528-21.019c24.106 0 43.65 19.543 43.65 43.648 0 24.107-19.544 43.649-43.65 43.649-24.106.003-43.649-19.539-43.649-43.646S8.422-21.019 32.528-21.019z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.386 48.691L32.528 75.739 19.672 48.691h25.714z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#FDFDFD",
    d: "M38.514-8.858c-.628 1.669-1.606 3.373-1.968 5.115-.333-1.695-1.24-3.257-2.383-4.54a.855.855 0 0 0-.666-.285c-.669 0-1.511.553-2.084.793-3.77 1.575-6.924 4.098-9.512 7.238-2.699 3.285-4.933 7-8.181 9.798-2.089 1.799-5.559 4-8.677 4-1.246 0-2.435-.348-3.456-1.217.014 5.182 5.203 9.886 9.37 11.984 1.459.731 2.979 1.372 4.573 1.738 1.576.356 2.568-.224 2.637 1.668.062 1.805-7.153 7.438-.866 15.301-.365-.46.291-1.538.94-2.142-.693.584.35 4.24 3.094 4.894-.377-.929-1.234-2.532-.994-3.555.866 3.846 3.727 3.171 6.951 3.653 2.824.427.761 2.689-.254 2.689a.44.44 0 0 1-.354-.151c.486.628 1.071.861 1.653.861 1.292 0 2.562-1.186 2.643-1.884.365 1.479-.01 3.128-2.096 3.128-.335 0-.716-.043-1.146-.139 1.068 1.063 2.128 1.474 3.138 1.474 2.077 0 3.944-1.737 5.242-3.129.01 1.095-.695 2.81-2.033 3.393.593.155 1.12.219 1.588.219 3.004 0 3.7-2.841 4.911-4.782-.091 1.038.423 3.391 2.05 3.391.542 0 1.206-.261 2.009-.92a9.363 9.363 0 0 1-1.056.069c-.785 0-.826-.186-.89-.285-.497-.825.095-2.029.667-2.636 1.345-1.428 3.385-1.731 4.591-3.404-.179.913-.659 1.834-1.275 2.521 1.817-1.139 3.572-2.863 4.083-5.021.681 1.401-.188 2.11-.722 3.285 5.265-3.14 2.997-7.159-.174-9.191 2.974-.233 4.552-4.198 2.318-5.76.086 1.531-1.244 2.927-2.86 2.927-.319 0-.652-.049-.988-.172 2.002-.73 3.888-4.693 1.407-5.294.443 1.447-.854 2.576-2.24 2.576a2.43 2.43 0 0 1-1.644-.628c1.118-1.392.518-3.055-.787-3.055-.25 0-.522.06-.808.188-.527-1.913.636-1.32 2.224-1.948 2.322-.927 4.582-2.51 6.347-4.273 2.729-2.731 4.384-6.102 5.525-9.745-.047.014-.098.033-.144.049a.04.04 0 0 0-.012.004l-.006.002.006-.002h.008a7.55 7.55 0 0 1-2.565.448c-4.271 0-8.433-3.493-10.075-7.252-1.881-4.305-2.32-9.694-7.059-11.996m-5.016 1.17h.018c1.586 1.639 2.93 5.766 2.93 5.766s2.296-5.38 2.509-5.683c2.574 1.67 3.531 4.558 4.542 7.605.385 1.164.777 2.365 1.275 3.497 1.651 3.771 6.026 7.781 10.887 7.781a8.29 8.29 0 0 0 1.353-.11c-1.194 3.281-2.739 5.802-4.785 7.853-1.784 1.786-3.94 3.236-6.053 4.08-.379.15-.731.218-1.073.28-.574.109-1.223.234-1.594.826-.369.588-.231 1.322-.074 1.894l.275.986.933-.42c.162-.076.312-.111.443-.111a.43.43 0 0 1 .421.267c.137.279.128.802-.315 1.363l-.523.646.618.553a3.3 3.3 0 0 0 2.229.856c.846 0 1.663-.314 2.263-.846-.379.817-1.245 1.588-1.849 1.868-.633.297-2.169.825-2.169.825l2.292.82c.417.148.85.226 1.282.226a3.775 3.775 0 0 0 2.733-1.191 4.14 4.14 0 0 0 .297-.353 2.426 2.426 0 0 1-.083.471c-.264.961-1.148 2.043-2.472 2.147l-2.608.208 2.198 1.412c1.426.911 2.94 2.487 2.916 4.172a2.934 2.934 0 0 1-.457 1.488 3.199 3.199 0 0 0-.299-.881l-1.076-2.214-.567 2.39a5.786 5.786 0 0 1-.914 1.958l.581-2.998-2.333 3.231c-.546.757-1.35 1.2-2.195 1.673-.795.439-1.62.897-2.319 1.641-.498.531-1.03 1.444-1.09 2.374-.151-.478-.212-.988-.174-1.31l.321-3.661-1.948 3.12c-.268.427-.514.89-.743 1.341-.881 1.702-1.553 2.799-2.952 2.997.563-.846.866-1.859.855-2.714l-.024-2.207-1.5 1.612c-1.139 1.228-2.856 2.852-4.6 2.852-.083 0-.16-.002-.242-.007.328-.193.559-.426.728-.638.603-.771.773-1.917.468-3.148l-1.153-4.687s-.08 3.719-.567 4.78c-.137.309-.445.632-.967.904.248-.35.419-.738.45-1.139.028-.394-.04-1.71-2.173-2.031a30.654 30.654 0 0 0-1.881-.201c-2.626-.214-3.81-.408-4.345-2.777l-.838-3.708-.874 3.694c-.096.398-.084.828-.002 1.259-.019-.028-.469-1.17-.441-1.913.037-1.061.717-2.55.636-2.48 0 0-2.145.919-2.729 2.114-2.842-4.711-.563-8.331.991-10.802.655-1.04 1.128-1.788 1.102-2.503-.076-2.183-1.386-2.291-2.341-2.364-.308-.028-.632-.051-.979-.129-1.329-.306-2.713-.833-4.371-1.664-3.854-1.941-7.754-5.677-8.683-9.539a6.41 6.41 0 0 0 2.373.43c4.037 0 8.099-3.225 9.246-4.212 2.293-1.97 4.092-4.385 5.833-6.721.791-1.061 1.607-2.157 2.454-3.184 2.63-3.192 5.715-5.542 9.172-6.985.185-.082.379-.177.582-.28.38-.192.893-.449 1.169-.449"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "#FDFDFD",
    d: "M35.588 2.192s-.039.235-.027.256c.032.014.126.01.161-.011 0-.071.003-.152-.009-.195-.013-.042-.044-.038-.125-.05"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "#FDFDFD",
    d: "M35.904 2.421a.603.603 0 0 0 .03-.215c-.029-.032-.07-.038-.128-.042l-.014.119c.004.072.014.207.112.138"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "#FDFDFD",
    d: "M35.679 2.842s.023.089.046.092c.021.009.048-.02.069-.045.163-.162-.175-.292-.115-.047"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#j)",
    fill: "#FDFDFD",
    d: "M34.818.17c.283-.035.532.215.416.535a.77.77 0 0 1-.533.416c-.202.029-.302-.114-.302-.301 0-.302.084-.611.419-.65m.628.72c.115 0 .178.267.229.696 0 0-.163-.055-.256-.045-.096.005-.21.068-.21.068-.021-.228.146-.719.237-.719m.711-.714c.474.071.58.94.055.969-.249.01-.579-.395-.539-.627.037-.235.333-.363.484-.342M34.055.061c.025-.138.116-.279.186-.417.049-.14.118-.324.278-.37-.045.14-.071.14-.113.254l-.073.255c-.043.115-.111.16-.138.279-.046.165-.017.554-.025.74-.014.311-.315.133-.311.416.012.282.496.375.682.467.184.119.14.232.32.344.471.207 1.094.097 1.162.052.19-.071.21-.257.398-.371.139-.071.442-.116.579-.325.186-.353-.185-.255-.256-.418-.046-.114.006-.582.044-.601.092-.049.03.486.092.507.205 0 .243-.349.26-.557.042-.646.013-1.79-1.646-1.832-1.626-.044-2.05 1.688-1.464 2.39.072-.213.005-.581.025-.813"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#l)",
    fill: "#FDFDFD",
    d: "M21.519 27.554a.954.954 0 0 0-.043.196c-.012.079-.01.132-.01.165.247.089.452.319.588.635.119.27.188.594.188.957 0 .896-.456 1.597-1.04 1.597-.582 0-1.039-.7-1.039-1.597 0-.523.049-.915.269-1.196-.041-.055-.093-.12-.114-.152-.016-.026-.118-.128-.226-.239-.201.315-.289.767-.289 1.466 0 1.125.646 2.228 1.3 2.228.658 0 1.451-.907 1.451-2.041 0-.407-.091-.802-.235-1.136-.19-.448-.476-.782-.8-.883"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#n)",
    fill: "#FDFDFD",
    d: "M22.318 26.478c-.493 0-.671-.363-.863-.742-.133-.264-.298-.397-.489-.581-.024-.022-.047-.043-.069-.066-.256-.255-.208-.483-.276-.813-.006-.024.013-.048.037-.051.014-.005.029-.004.044.012.052.063.114.118.178.177.271.227.607.425.738.741.108.242.2.671.433.849-.093-.543-.087-1.264-.561-1.52-.255-.139-.502-.234-.45-.573.065-.416.208-.928.222-1.412a8.15 8.15 0 0 0-.74-1.408c-.223.162-.32.553-.363.881-.034.289-.029.526-.029.527 0 .018-.167-.412-.22-.847-.028-.21-.028-.422.029-.593.049-.131.142-.291.265-.407a5.383 5.383 0 0 0-.353-.407c-.442-.465-.877-.521-1.129.178a3.169 3.169 0 0 0-.077.243c-.087.286-.136.606-.041.886a.873.873 0 0 0 .102.208c.165.235.337.453.491.692.017.021 0 .043-.022.047-.01.006-.021.001-.031-.006-.252-.302-.636-.584-.775-.97-.008-.027-.019-.047-.025-.071-.076-.284-.065-.592-.016-.891.016-.136.042-.271.075-.401.214-.919 1.307-.811 1.498-.627.506.307.889.873 1.187 1.351.454.746.76 1.643.608 2.518-.01.053-.077.065-.093.01-.014-.041-.026-.079-.041-.119-.01.111-.028.217-.036.312-.01.042-.053.371-.063.371.093.046.192.083.276.137.164.102.351.225.442.402.259.507.314 1.21.351 1.771-.002.11-.116.192-.214.192m-.241-5.488c-.158-.372-.312-.779-.535-1.113-.119-.177-.253-.339-.385-.503a3.963 3.963 0 0 0-.368-.261c-.401-.25-.92-.604-1.395-.707-.564-.121-.987.445-1.264.855a3.982 3.982 0 0 0-.634 1.828c-.04.452-.14 1.014.228 1.363.428.404.934.713 1.384 1.09.394.33.715.747.861 1.214.079-.46.079-.914-.143-1.38-.005-.01.004-.02.014-.016l.01.006c.377.561.418 1.118.336 1.789-.028.242-.187 1.365-.065 1.874.133.55.392 1.21.939 1.481.256.127.512.144.759.1-.118-.257-.289-.436-.484-.485l-.056-.013-.027-.052c-.01-.018-.05-.125-.02-.343.033-.255.1-.362.113-.377l.045-.063.077.014c.433.08.819.479 1.062 1.022.029-.016.058-.031.083-.052.258-1.459.322-3.01.189-4.478-.086-.977-.341-1.894-.724-2.793"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#p)",
    fill: "#FDFDFD",
    d: "M25.959 15.833c1.255-.668 1.116-1.394 2.749-2.061-1.502-.551-1.796.453-2.876 1.095-1.234.729-1.528-.932-.794-1.607.604-.559 1.843-1.402 2.894-1.584 2.013-.344 3.854.637 5.033 2.352.872 1.27 2.237-.117 2.009-.649.679.941-.098 3.04-1.291 2.349.034.774.143 1.477.018 2.261-.979-2.709-1.33-1.889-3.561-1.731-1.082.074-3.342.559-4.181-.425m9.275 7.353c-.121.191-1.926-.492-1.843-.877.068-.309.443-.137.656-.057.335.133 1.391.605 1.187.934m-2.177.356c-3.079-2.054 1.494-4.16 1.774-2.14-1.015-.993-3.229.636-1.476 1.641 1.357.78 2.766.94 3.825-.231.557-.295.37-1.212.262-1.722l.008-.001c-.335-1.611.287-2.958-.618-4.422-.769-1.244-.646-2.675-.432-4.051-.012.067-3.002-1.256-3.353-1.388-2.359-.891-3.646-1.232-5.977-.204l-2.749 1.801c-1.25 1.14-1.345 1.787-1.119 3.479.101.774 1.716 1.953 1.721 2.067.105 1.827.061 3.991-.268 5.79 1.501-.781 2.424.591 1.72 1.383-.185.213-.036-.209-.08-.282-.518-.98-1.971.76-.733 1.475.977.567 2.099-.486 2.606-1.154 1.099-1.449 2.281-3.779 4.889-2.041"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#r)",
    fill: "#FDFDFD",
    d: "M37.763 5.474c.014.278-.296.52-.529.497-.091-.023-.307-.141-.371 0-.083.17.106.271.209.301.302.092.601-.083.691-.13.361-.182.389-.595.402-.642.95.075.749.075 1.569.194.423.063.471-.561.187-.699-.285-.136-.755.048-1.4-.063.255-.537.498-.562.587-.585-.044-.067-.242-.455-.599-.169-.209.166-.142.35-.382.67 0 0-4.428-.399-7.941-5.415-.395.966 2.703 5.464 7.577 6.041"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "#FDFDFD",
    d: "M35.403 2.727c-.071.048-.076.133-.047.174.027.045.085.045.114.033a.165.165 0 0 0 .063-.121c.001-.053-.029-.096-.13-.086"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#v)",
    fill: "#FDFDFD",
    d: "M36.564 4.325c3.989-2.013 4.308-4.662 4.264-4.776-.348.485-2.25 3.037-5.26 4.391.36.186.874.336.996.385"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#x)",
    fill: "#FDFDFD",
    d: "M36.525 28.613c.027-.15.035-.309.026-.459-.013-.26-.019-.53-.182-.75-.086-.125-.363-.304-.529-.317a2.147 2.147 0 0 0-.268.616c-.075.303-.023.572-.044.874.03.026.057.049.064.096.177.034.355.066.532.077.15.011.362.066.401-.137"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#z)",
    fill: "#FDFDFD",
    d: "M31.145 4.728c-.235-.029-.496.019-.482.391.009.291.293.347.392.339l1.012-.024.566-.039a.863.863 0 0 0 .376.601c.21.138.397.228.654.158.139-.045.274-.138.21-.299-.073-.165-.33 0-.493-.046-.146-.067-.315-.266-.34-.444 0 0 .705.018 2.193-.466-.269-.127-1.035-.529-1.035-.529s-.926.242-1.561.315a.977.977 0 0 1-.178-.246c-.07-.161-.07-.395-.188-.51-.208-.165-.487-.025-.554.209.36.094.426.358.538.591-.005.001-.723.042-1.11-.001"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#B)",
    fill: "#FDFDFD",
    d: "M35.101 2.286s-.011-.105-.031-.117c-.021-.008-.063 0-.083 0-.177.084.047.395.114.188v-.071z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    fill: "#FDFDFD",
    d: "M31.51 9.878c4.268 1.329 8.01 3.467 11.636 6.057-.521-2.515-3.708-6.632-11.636-6.057"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#F)",
    fill: "#FDFDFD",
    d: "M35.375 2.204c-.049.045-.067.194.003.245.041.007.114.021.139-.072V2.31s0-.076-.024-.116c-.024-.002-.092-.013-.118.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#H)",
    fill: "#FDFDFD",
    d: "M35.145 2.816c0 .026.027.073.045.096.095.046.139-.185.071-.208-.044-.024-.091 0-.141 0l.025.112z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#J)",
    fill: "#FDFDFD",
    d: "M35.313 2.423l-.005-.138c-.025-.092-.091-.116-.139-.068-.027.047-.027.161-.027.209.066.03.171-.003.171-.003"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#L)",
    fill: "#FDFDFD",
    d: "M34.937 2.678c0 .06.01.13.03.165.024.033.114.036.134.024.018-.021-.018-.113-.039-.138-.019-.027-.056-.038-.125-.051"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#N)",
    fill: "#FDFDFD",
    d: "M34.753 2.678c-.117-.207.044-.416-.211-.669-.046-.024-.114-.092-.16-.093-.102-.004-.039.285-.033.506.015.425.035.457.265.649.09.139.162.281.323.351.21.07.903.07 1.069-.023.159-.093.467-.53.482-.65.017-.122.023-.391.094-.789-.069.024-.158.024-.233.067-.229.165-.114.557-.322.814-.093.116-.302.159-.464.159-.302.002-.671-.02-.81-.322"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#P)",
    fill: "#FDFDFD",
    d: "M34.921 30.775c.33-.335.382-1.021.379-1.508a3.006 3.006 0 0 1-.943-.028c.003.237.01.47.069.717.022.119.257 1.06.495.819"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#R)",
    fill: "#FDFDFD",
    d: "M33.165 30.419a2.073 2.073 0 0 1-.171-1.492l-.106-.047c-.02.029-.058.052-.094.047a1.098 1.098 0 0 0-.609.039c.007 1.115.73 1.367.98 1.453"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#T)",
    fill: "#FDFDFD",
    d: "M36.827 29.226c-.006.027-.076.434.021.73.037.119.051.266.103.414.006-.005.013-.005.021-.008.419-.083.512-.776.623-1.137a4.191 4.191 0 0 1-.768.001"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#V)",
    fill: "#FDFDFD",
    d: "M37.765 31.124c.086.035 3.246.359 2.743 1.32.087-.431-2.634-1.15-5.394-.631-1.781.335-4.019-.353-4.938-1.448-.624-.746-.73-.959-1.214-1.95-.389 1.93.301 4.84 2.748 7.105 1.136 1.053 3.116.449 2.038-.241-.462-.296-1.666-1.145-1.905-1.528.727.091 2.163-.942 4.197-1.178 1.91-.22 3.308-.249 3.924 1.066-.615-.451-1.848-.255-1.859-.272.702.88 1.188.719 2.256.568.504-.067-.62.713-1.566.586-.579-.077-.221 1.148-.097 1.712.904-.363 1.468-.257 2.112-.836 1.375-1.2.773-8.082.083-8.667-.06 2.374-.989 4.086-3.128 4.394"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#X)",
    fill: "#FDFDFD",
    d: "M37.765 28.345a2.864 2.864 0 0 0-.187-.934 4.13 4.13 0 0 1-.352-.348c-.237.538-.406 1.042-.431 1.655.405.056.993.143.97-.373"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#Z)",
    fill: "#FDFDFD",
    d: "M32.645 27.696a4.51 4.51 0 0 0-.052-.301c-.158.024-.316.042-.476.059a1.177 1.177 0 0 0-.044.211c.04.246.038.509.026.752.187-.045.375-.045.568-.025 0-.027.002-.052.004-.079a1.292 1.292 0 0 1-.041-.502l.015-.115"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ab)",
    fill: "#FDFDFD",
    d: "M33.301 29.114c.074.374.055.768.214 1.126.056.119.111.244.187.353.104.146.155.143.314.109.028-.005.051 0 .067.013.072-.19.078-.449.114-.604-.096-.244-.082-.838-.082-.903.003-.068-.316-.05-.814-.094"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ad)",
    fill: "#FDFDFD",
    d: "M31.714 28.024a5.591 5.591 0 0 0-.089-.904c-.092.018-.185.029-.275.043a3.196 3.196 0 0 0-.01.47c.022.28.125.42.374.391"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ae",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#af)",
    fill: "#FDFDFD",
    d: "M32.058 30.071c.101.063.185.023.255-.048a1.252 1.252 0 0 1-.237-.3c-.219-.386-.28-.861-.125-1.271-.011.005-.364.093-.572-.084.055.948.498 1.579.679 1.703"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ah)",
    fill: "#FDFDFD",
    d: "M30.801 28.007c.083 1.577.544 1.535.646 1.527-.004-.01-.01-.015-.014-.026-.247-.42-.455-1.02-.354-1.527-.019.012-.197.067-.278.026"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#aj)",
    fill: "#FDFDFD",
    d: "M44.12 19.607c-.25-.396-.969-2.354-1.074-2.439-.893 2.149-3.278 2.586-5.108 1.29.071.851-.138 1.742.052 2.584.254.719.128 1.327-.39 1.829 1.745-1.305 1.204-.014-.116.615-.346.162-.672.329-1.01.499.789-.233 1.741-.182 2.686-1.198.877-.952-.393-1.593-.592-1.44.52-.811 2.587.73.982 1.619 1.015-.009 1.891.916 2.293 1.417.088-.672.768-2.147 1.573-2.147.79-.787 1.386-1.554.704-2.629"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ak",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#al)",
    fill: "#FDFDFD",
    d: "M39.22 28.603c.04.013.079.042.092.088.003-.005.005-.01.015-.015a.653.653 0 0 0 .084-.371 3.02 3.02 0 0 0 0-.485.363.363 0 0 1-.127.138c.021.185.008.365-.042.557l-.022.088"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "am",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#am",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#an)",
    fill: "#FDFDFD",
    d: "M37.965 27.105c.09.315.102.659.019.902-.003.01-.011.274-.016.282.187.044.367-.063.558 0 .023-.3-.083-.613-.035-.904a2.984 2.984 0 0 1-.526-.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ao",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ao",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ap)",
    fill: "#FDFDFD",
    d: "M35.577 29.301c-.01.389-.035.886.146 1.213.188.338.461-.268.508-.422.071-.223.119-.503.19-.727-.267.052-.572-.012-.844-.064"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aq",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aq",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ar)",
    fill: "#FDFDFD",
    d: "M37.968 28.771s-.007.275.018.441c.026.125.05.27.094.41.241-.262.351-.551.449-.877-.193-.049-.561.026-.561.026"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "as",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#as",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#at)",
    fill: "#FDFDFD",
    d: "M38.7 28.684c.06.098.013.23.057.348.027.072.065.028.109-.037.124-.192.181-.436.21-.68l-.018-.018a.31.31 0 0 1-.021-.104 1.147 1.147 0 0 1-.29-.005c.012.168 0 .333-.047.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "au",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#au",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#av)",
    fill: "#FDFDFD",
    d: "M38.808 27.832c.021-.037.053-.081.074-.119.027-.048.056-.094.082-.144-.019-.128-.011-.329-.047-.502-.075-.017-.143-.032-.218-.059.011.089.018.17.025.198.037.19.076.395.068.596a.185.185 0 0 0 .016.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aw",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aw",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ax)",
    fill: "#FDFDFD",
    d: "M35.106 27.148c-.098.108-.579.298-.688.396-.088.261-.16.516-.165.817-.017.457.501.377.854.324-.025-.534.067-1.069-.001-1.537"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ay",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ay",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#az)",
    fill: "#FDFDFD",
    d: "M30.189 16.011c.18-.023 1.329-.02 1.388-.374-.632-.248-1.188-.649-1.775-.846.392.256.611.761.387 1.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aA",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#aB)",
    fill: "#FDFDFD",
    d: "M28.858 14.711c-.491.085-1.032.398-1.667 1.106-.211.365 1.039.35 1.383.336a.933.933 0 0 1 .284-1.442"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    d: "M-156.974-70.949H224.69v269.865h-381.664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aC",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#aD)",
    fill: "#FDFDFD",
    d: "M29.048 15.066c.102.018.19.076.23.188.034.108-.02.282-.207.29a.249.249 0 0 1-.257-.296c.022-.114.131-.203.234-.182"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerHover);
export default __webpack_public_path__ + "static/media/map_marker_hover.b43723d99a1caf4c89c40fc94f7f39d3.svg";
export { ForwardRef as ReactComponent };